"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("../../../utilities/createSvgIcon"));
var _WhatsAppLG = _interopRequireDefault(require("./WhatsAppLG"));
/** @deprecated Use the icon component from `@busbud/horizon`. */
var _default = exports.default = (0, _createSvgIcon.default)(_WhatsAppLG.default, 'WhatsApp', 'LG');